import getBasePath from '../../../../common/functions/api-resource';

const basePath = getBasePath('api', 'configuracao-tatico/planejamento');

const configuracaoWorkflowContratoActions = {
  atualizar: { method: 'POST', url: `${basePath}/atualizar` },
  salvar: { method: 'POST', url: `${basePath}/salvar` },
  pesquisar: { method: 'GET', url: `${basePath}/{chave}` },
};
export default resource => resource(`${basePath}`, {}, configuracaoWorkflowContratoActions);



// WEBPACK FOOTER //
// ./src/custom/abbrasil/common/resources/configuracao-planejamento.js